<div class="card">
    <div class="card-header mm-card-header">Jobs</div>
    <div class="card-body">
        <div class="scheduler-jobs-row d-flex align-items-center gap-3 mb-3">
            <p-select
                data-identifier="dev-tool-job-select"
                [options]="jobs"
                [(ngModel)]="selectedJob"
                optionLabel="displayName"
                optionDisabled="disabled"
                placeholder="Select a job"
                [loading]="isLoadingJobs"
                [disabled]="isLoadingJobs"
                styleClass="dev-tool-select">
                <ng-template pTemplate="item" let-job>
                    <div class="d-flex align-items-center justify-content-between gap-2">
                        <span>{{ job.displayName }}</span>
                        <span *ngIf="job.disabled" class="badge text-bg-secondary fw-normal">Disabled</span>
                    </div>
                </ng-template>
            </p-select>

            <button
                data-identifier="dev-tool-trigger-button"
                type="button"
                class="btn btn-sm btn-primary trigger-button"
                [disabled]="!selectedJob || isTriggering || selectedJob.disabled || (selectedJob.requiresPayload && !payload.trim())"
                (click)="triggerJob()">
                <span *ngIf="isTriggering" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                {{ isTriggering ? 'Triggering...' : 'Trigger Job' }}
            </button>
        </div>

        <div class="mb-3" *ngIf="selectedJob?.requiresPayload">
            <label for="dev-tool-job-payload" class="form-label mb-1">Payload (required)</label>
            <textarea
                id="dev-tool-job-payload"
                data-identifier="dev-tool-job-payload"
                class="form-control dev-tool-job-payload"
                rows="3"
                aria-required="true"
                [disabled]="isTriggering"
                [(ngModel)]="payload"
                placeholder="Payload for the selected job — see its documentation for the required format."></textarea>
        </div>

        <p class="text-muted small mb-0" *ngIf="!selectedJob?.requiresPayload">
            Select a job from the dropdown and click <strong>Trigger Job</strong> to run it immediately.
            The job runs asynchronously in the background.
        </p>
        <p class="text-muted small mb-0" *ngIf="selectedJob?.requiresPayload">
            This job runs synchronously — keep this page open until the success toast appears.
        </p>
    </div>
</div>
